<template>
  <div>
    <div class="row">
      <div class="col-lg-3 col-md-4">
        <ul class="list-group sticky-top sticky-offset">
          <button
            class="btn btn-block btn-outline-secondary my-1 text-uppercase"
            @click="doCompose()"
          >
            Compose <i class="align-middle icon-pencil" />
          </button>
          <div class="nav nav-pills py-2 flex-md-column justify-content-center">
            <button
              class="btn btn-link nav-link text-left active"
              title="Messages"
              data-toggle="tab"
              data-target="#messages"
            >
              <span class="icon icon-envelope fa fa-fw fa-envelope mr-md-1" />
              <span class="d-none d-md-inline">Messages</span>
              <span
                class="badge badge-pill badge-dark small font-weight-light ml-1"
                title="Unread"
              >
              </span>
            </button>
            <button
              class="btn btn-link nav-link text-left"
              title="Deleted"
              data-toggle="tab"
              data-target="#deleted"
            >
              <span class="icon icon-trash fa fa-fw fa-trash mr-md-1" />
              <span class="d-none d-md-inline">Deleted</span>
              <span
                class="badge badge-pill badge-dark small font-weight-light ml-1"
                title="Deleted"
              >
                {{ deleted.length }}
              </span>
            </button>
            <button
              class="btn btn-link nav-link text-left"
              title="Drafts"
              data-toggle="tab"
              data-target="#drafts"
            >
              <span class="icon icon-pencil fa fa-fw fa-edit mr-md-1" />
              <span class="d-none d-md-inline">Drafts</span>
            </button>
          </div>
          <div class="d-md-block d-none">
            <hr />
          </div>
        </ul>
      </div>
      <div class="col-md tab-content">
        <div id="messages" class="tab-pane active">
          <div class="d-flex flex-sm-row flex-column py-1 mb-1">
            <div class="btn-group">
              <button
                type="button"
                class="btn btn-outline-secondary text-uppercase"
                @click="toggleMarkAll"
              >
                <div
                  class="custom-control custom-checkbox"
                  @click="toggleMarkAll"
                >
                  <input
                    type="checkbox"
                    class="custom-control-input"
                    id="checkAll"
                    defaultChecked="false"
                    @change="toggleMarkAll"
                  />
                  <label
                    class="custom-control-label"
                    for="checkAll"
                  >
                    Mark
                  </label>
                </div>
              </button>
              <div class="btn-group mr-sm-auto mr-none">
                <button
                  type="button"
                  class="btn btn-outline-secondary dropdown-toggle text-uppercase"
                  data-toggle="dropdown"
                />
                <div class="dropdown-menu" id="dd1">
                  <button
                    class="dropdown-item"
                    @click="deleteMarked"
                  >
                    Delete marked items
                  </button>
                </div>
              </div>
            </div>
            <button
              type="button"
              class="btn btn-outline-secondary mx-sm-1 mx-none"
              @click="refreshMessages"
            >
              <i class="align-middle icon-refresh fas fa-sync" />
            </button>
            <button
              type="button"
              class="btn btn-outline-secondary mr-sm-1 mr-none"
              data-target="#composeModal"
              data-toggle="modal"
            >
              <i class="align-middle icon-pencil fa fa-edit" />
            </button>
          </div>
          <ul class="list-group py-2" v-for="(item, idx) in messages" :key="idx">
            <li class="list-group-item list-group-item-action d-block py-1">
              <summary class="row">
                <div class="col py-2 order-1">
                  <div
                    @click="toggleMark(idx)"
                    class="custom-control custom-checkbox"
                  >
                    <input
                      type="checkbox"
                      class="custom-control-input"
                      name="'check' + idx"
                      :checked="item.marked === 1"
                      @change="toggleMark(idx)"
                    />
                    <label
                      class="custom-control-label text-nowrap"
                      for="'check' + idx"
                    >
                      <a
                        title="send mail"
                        :href="'mailto:' + item.fromAddress"
                      >
                        {{ item.from }} 
                        <span class="icon icon-envelope far fa-fw fa-envelope mr-md-1" />
                      </a>
                    </label>
                  </div>
                </div>
                <div class="col-auto px-0 order-last order-sm-2 d-none d-sm-block align-self-center text-right">
                  <button
                    class="btn btn-link text-primary px-md-1"
                    title="Delete"
                    @click="doDelete(idx)"
                  >
                    <span class="icon icon-trash fa fa-fw fa-trash" />
                  </button>
                </div>
                <div
                  class="col-sm-12 col-10 py-2 order-3"
                  @click="doShow(idx)"
                >
                  <div class="float-right text-right">
                    <span>
                      {{ item.dtSent }}
                    </span>
                  </div>
                  <p class="lead mb-0">
                    <button
                      class="btn btn-link"
                      title=""
                      @click="doShow(idx)"
                    >
                      {{ item.subject }}
                    </button>
                    <i v-if="item.attachment" class="align-middle fa fa-paperclip icon-paper-clip" />
                    <button
                      type="button"
                      class="btn btn-outline-secondary btn-sm ml-2 d-none d-md-inline"
                      @click="doShow(idx)"
                    >
                      Open
                    </button>
                  </p>
                </div>
              </summary>
            </li>
          </ul>
        </div>
        <div id="deleted" class="tab-pane">
          <h5>Deleted items 
            <span
              class="badge badge-pill badge-primary small font-weight-light ml-1"
              title="Deleted"
            >
              {{ deleted.length }}
            </span>
          </h5>
          <div class="row">
            <div class="col-12" v-for="(item, idx) in deleted" :key="idx">
              <button class="btn btn-link text-left">
                {{ item.from }} ( {{ item.fromAddress }} )
                <span class="px-2">
                  {{ item.subject.substring(0, 20) }}...
                </span>
              </button>
            </div>
          </div>
        </div>
        <div id="drafts" class="tab-pane">
          <h5>Drafts</h5>
          <p>Not implemented..</p>
        </div>
        <div id="calendar" class="tab-pane">
          <h5>Calendar</h5>
          <p>Not implemented..</p>
        </div>
      </div>
    </div>
    <ModalCompose ref="modalCompose" :sendTo="selected.fromAddress" />
    <ModalMessage ref="modalMessage" :message="selected" />
  </div>
</template>

<script>
import ModalCompose from "./ModalCompose";
import ModalMessage from "./ModalMessage";
import messages from "./data/messages.json";

export default {
  data(){
    return {
      initMessages: messages,
      messages: messages,
      selected: {},
      deleted: []
    }
  },
  components: {
    ModalCompose,
    ModalMessage
  },
  methods: {
    markRead(idx) {
      /* mark this message as read */
      let messages = [...this.messages];
      messages[idx].read = true;
      this.messages = messages;
    },
  
    doShow(idx) {
      this.markRead(idx);
      this.selected = messages[idx];
      /* open message in modal */
      this.$refs.modalMessage.show();
    },
  
    doCompose() {
      /* open compose modal */
      this.$refs.modalCompose.show();
    },
  
    toggleMark(idx) {
      let messages = [...this.messages];
      messages[idx].marked = messages[idx].marked ? 0 : 1;
      this.messages = messages;
    },
  
    doDelete(idx) {
      let messages = [...this.messages];
      let deleted = [...this.deleted];
      /* append it to deleted */
      deleted.push(messages[idx]);
      /* remove the message at idx */
      messages.splice(idx, 1);
      this.messages = messages;
      this.deleted = deleted;
    },
  
    toggleMarkAll() {
      let messages = [...this.messages];
      messages.map((v) => {
        return (v.marked = v.marked ? 0 : 1);
      });
      this.messages = messages;
    },
  
    deleteMarked() {
      var self = this;
      let messages = [...this.messages];
      var tbd = [];
      for (var k = 0; k < messages.length; k++) {
        if (messages[k].marked === 1) {
          tbd.push(k);
        }
      }
  
      if (tbd.length > 0) {
        self.deleteMessages(tbd);
      }
    },
  
    refreshMessages() {
      let initMessages = [...this.initMessages];
      this.messages = initMessages;
    },
  
    deleteMessages(arr) {
      let messages = [...this.messages];
      let deleted = [...this.deleted];
      for (var i = arr.length - 1; i >= 0; i--) {
        deleted.push(messages[i]);
        messages.splice(arr[i], 1);
      }
      this.messages = messages;
      this.deleted = deleted;
    }
  }
}
</script>
